import {UserInputSelectAccessProfile} from '@/features/users/components/user-input-select-access-profile/UserInputSelectAccessProfile'
import {Controller, useFormContext, useWatch} from 'react-hook-form'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {useTranslation} from '@/translations/i18n'
import {UserAccessProfileValidationSchema} from '@/features/users/types'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Switch} from '@/components/commons/switch/Switch'
import {StyledUserAccessProfileSwitchContainer} from './style'
import {UserPermissionsForm} from '@/features/users/components/user-permissions-form/UserPermissionsForm'
import {useEffect} from 'react'

export const UserAccessProfileForm = ({hideRoleGridHeader}: {hideRoleGridHeader?: boolean}) => {
    const {t} = useTranslation()

    // methods
    const form = useFormContext<UserAccessProfileValidationSchema>()

    // form observer
    const role = useWatch({control: form.control, name: 'role'})
    const permissionsOverwritten = useWatch({control: form.control, name: 'permissionsOverwritten'})
    const permissions = useWatch({control: form.control, name: 'permissions'})

    useEffect(() => {
        if (permissions?.length == 0 && role) {
            form.setValue(
                'permissions',
                role.defaultPermissions.map(permission => permission.name)
            )
        }
    }, [role, permissions])

    return (
        <Flexbox direction="column" gap={6} fullWidth>
            {!hideRoleGridHeader && (
                <Grid columns={6} fullWidth gap={4}>
                    <GridItem startColumn={1} endColumn={4}>
                        <Controller
                            control={form.control}
                            name="role"
                            render={({field}) => (
                                <UserInputSelectAccessProfile
                                    label={t('users:select_access_profile')}
                                    onChange={value => {
                                        field.onChange(value)
                                        form.setValue(
                                            'permissions',
                                            value?.defaultPermissions.map(permission => permission.name)
                                        )
                                    }}
                                    value={field.value}
                                />
                            )}
                        />
                    </GridItem>

                    {role && (
                        <StyledUserAccessProfileSwitchContainer startColumn={4} endColumn={7}>
                            <Controller
                                control={form.control}
                                name="permissionsOverwritten"
                                render={({field}) => (
                                    <Switch
                                        label={t('users:overwrite_permissions')}
                                        defaultChecked={field.value}
                                        size="sm"
                                        onChange={value => {
                                            field.onChange(value)
                                            form.setValue(
                                                'permissions',
                                                role.defaultPermissions.map(permission => permission.name)
                                            )
                                        }}
                                    />
                                )}
                            />
                        </StyledUserAccessProfileSwitchContainer>
                    )}
                </Grid>
            )}

            {role && (
                <UserPermissionsForm
                    isReadOnly={!!hideRoleGridHeader}
                    isOverwrittenEnabled={!!permissionsOverwritten}
                />
            )}
        </Flexbox>
    )
}
